<div id="selectEndUser" class="subBlockContainer">
  <div class="subBlockContent">
    <child-header [title]="title" (closeEvent)="close()"></child-header>
    <div class="child-body">
      <div class="inner-subBlock-wrapper">
        <div class="row">
          <div class="searchInputGroup searchInputGroup-margin col-md-6">
            <div class="searchIcon search-carts">
              <img src="../images/new_ui/filter.png">
            </div>
            <input class="searchInput" placeholder="Filter" onfocus="this.placeholder=''" onblur="this.placeholder='Filter'" type="text" [(ngModel)]="filterInput"
              (ngModelChange)="searchEndUserAddressBook()">
          </div>
          <!-- <mat-form-field class="col-md-6">
            <mat-select [(value)]="selectedSalesType">
              <mat-option *ngFor="let salesType of salesTypes" (click)="selectSalesType(salesType?.out_sales_type)"
                [value]="salesType?.out_sales_type">
                {{salesType?.out_sales_type_desc?.split(' ')[0]}}
              </mat-option>
            </mat-select>
          </mat-form-field> -->
        </div>

        <div class="top-divider"></div>

        <div class="div-select" *ngFor="let endUserAddressBook of endUserAddressBooksFilter">
          <section class="address-content">
            <div class="address-col">
            <div class="payment-name-wrapper">{{endUserAddressBook?.out_first_name}} {{endUserAddressBook?.out_last_name}}
            </div>
            <div>{{endUserAddressBook?.out_company_name}}</div>
            <div class="enduser-email">{{endUserAddressBook?.out_email}}</div>
            <div>{{endUserAddressBook?.out_mobile}}</div>
            <div>{{endUserAddressBook?.out_phone}}</div>
            <div>{{endUserAddressBook?.out_fax}}</div>
            <div>
              <span>{{endUserAddressBook?.out_address_1}}</span>
              <span>{{endUserAddressBook?.out_address_2}}</span>
              <span>{{endUserAddressBook?.out_address_3}}</span>
              <span>{{endUserAddressBook?.out_address_4}}</span>
              <span>{{endUserAddressBook?.out_address_5}}</span>
            </div>
            <div>
              <span>{{endUserAddressBook?.out_suburb}}</span>
              <span>{{endUserAddressBook?.out_state}}</span>
              <span>{{endUserAddressBook?.out_country}}</span>
            </div>
            <div>{{endUserAddressBook?.out_postcode}}</div>
          </div>
          <div class="select-button-col">
            <button class="button button-red button-mid" (click)="selectEndUser(endUserAddressBook)">Select</button>
          </div>
          </section>
        </div>
      </div>
      <loading-screen *ngIf="!loadContent" backDropWidth='348' [showBlurTable]="false" (currentLoadingStatus)="onLoading($event)"></loading-screen>
    </div>
  </div>
</div>